import { Skeleton } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { storageUrlWithCredentials } from "../imagesPreview/storageUrlWithCredentials";

interface Props {
  image:
    | {
        name: string;
        thumbnail: { url: string };
        original: { url: string };
        www: { url: string };
      }
    | undefined
    | null;
  thumbnailSize?: number | "auto";
}

const ImagePreview: FC<Props> = ({ image, thumbnailSize = 300 }) => {
  const [thumbnailSignedUrl, setThumbnailSignedUrl] = useState<string>();
  useEffect(() => {
    if (image?.thumbnail.url) {
      storageUrlWithCredentials(image?.thumbnail.url).then((url) => setThumbnailSignedUrl(url));
    } else {
      setThumbnailSignedUrl(undefined);
    }
  }, [image?.thumbnail.url]);

  const handleClick = () => {
    if (image?.original.url) {
      storageUrlWithCredentials(image.original.url).then((url) => window.open(url, "_blank"));
    }
  };

  if (!image?.thumbnail.url) {
    return null;
  }
  if (!thumbnailSignedUrl) {
    return <Skeleton variant="rectangular" width={thumbnailSize} height={thumbnailSize} />;
  }
  return (
    <img
      style={{
        width: thumbnailSize,
        height: thumbnailSize,
      }}
      alt={image.name}
      src={thumbnailSignedUrl}
      onClick={handleClick}
    />
  );
};

export default ImagePreview;
